module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "subview-container column client"
  }, [_c('notifications', {
    attrs: {
      "classes": "master-notifications",
      "position": "top left",
      "group": "default"
    }
  }), _vm._v(" "), (_vm.client.certified === 'NOT CERTIFIED') ? _c('div', {
    staticClass: "contentrow alone certified row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.certified = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-contact"
  }), _vm._v("\n\t\t\t\tLancer la vérification\n\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.client.certified === 'PENDING') ? _c('div', {
    staticClass: "contentrow alone certified row"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "half head-profil row"
  }, [_c('router-link', {
    staticClass: "btn btn-red small",
    attrs: {
      "to": {
        name: 'Contacts'
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-profile-picture"
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.profilePicture,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-info-name column"
  }, [_c('div', {
    staticClass: "name bold row"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname) + " "), (_vm.client.certified === 'CERTIFIED') ? _c('img', {
    attrs: {
      "src": _vm.good,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "subscribed"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s((_vm.client.type === 'client_subscriber') ? 'Client' : 'Prospect') + "\n\t\t\t\t\t")]), _vm._v(" "), (!_vm.client.lcbft_completed) ? _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.lcbcft = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-warning"
  }), _vm._v("\n\t\t\t\t\t\tRemplir le formulaire LCB-FT\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta column"
  }, [_c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "to": {
        name: 'ChatClient'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tConversations\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.takeAppointment = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-rdv"
  }), _vm._v("\n\t\t\t\t\t\tPlanifier un RDV\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "half notes"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": function($event) {
        return _vm.launchNoteModal(true)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNouvelle note\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "boding"
  }, [(!_vm.client.notes || _vm.client.notes.length === 0) ? _c('div', {
    staticClass: "no-notes empty"
  }, [_vm._v("\n\t\t\t\t\t\tPrenez quelques note sur votre client en cliquant sur « Nouvelle note »\n\t\t\t\t\t")]) : _c('div', {
    staticClass: "notes row"
  }, _vm._l((_vm.client.notes), function(note) {
    return _c('div', {
      staticClass: "note row",
      on: {
        "click": function($event) {
          return _vm.launchNoteModal(false, note)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(note.title) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(note.created_at.split(' ')[0]) + "\n\t\t\t\t\t\t\t")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "contentrow alone row"
  }, [(_vm.client.investment_stats && !Array.isArray(_vm.client.investment_stats)) ? [_c('div', {
    staticClass: "info-value row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tMontant investi\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("format_currency")(_vm.client.investment_stats.amount_invested, '€')) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "info-value row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tAvoirs\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("format_currency")(_vm.client.investment_stats.my_assets, '€')) + "\n\t\t\t\t")])]), _vm._v(" "), (!_vm.client.investment_stats.hide_performance) ? _c('div', {
    staticClass: "info-value row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tPerformance globale\n\t\t\t\t")]), _vm._v(" "), (_vm.client.investment_stats.global_performance) ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("format_performance")(_vm.client.investment_stats.global_performance)) + "%\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [(_vm.client.investment_stats.global_performance >= 0) ? _c('img', {
    attrs: {
      "src": _vm.highIcon,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.downIcon,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'InvestmentsManual',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-file-edit"
  }), _vm._v(" Agrégation manuelle\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "to": {
        name: 'InvestmentsClient',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-situation"
  }), _vm._v(" Situation détaillée\n          ")])], 1)])] : [_c('div', {
    staticClass: "no-investments column"
  }, [_c('p', [_vm._v("\n          Votre client n'a pas encore investit\n        ")]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'InvestmentsManual',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-file-edit"
  }), _vm._v(" Agrégation manuelle\n          ")])], 1)])]], 2), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "half story"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "add row"
  }, [(_vm.client.lcbft_completed) ? _c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'MyTransactionsAdd'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNouvelle Opération\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'TransactionsTable'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tVoir tout\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "boding"
  }, [(_vm.client.missions.length === 0) ? _c('div', {
    staticClass: "no-story empty"
  }, [_vm._v("\n\t\t\t\t\t\tAucune opérations enregistrée.\n\t\t\t\t\t\t"), (!_vm.client.lcbft_completed) ? _c('div', [_vm._v("\n\t\t\t\t\t\t\tRemplissez le formulaire LCBC-FT de votre client"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tavant de créer une nouvelle opérations\n\t\t\t\t\t\t")]) : _vm._e()]) : _c('div', {
    staticClass: "stories"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "stories-body column"
  }, _vm._l((_vm.client.missions), function(mission, key) {
    return _c('div', {
      key: key,
      staticClass: "stories-row row"
    }, [_c('div', {
      staticClass: "stories-column"
    }, [_vm._v(_vm._s(mission.title))]), _vm._v(" "), _c('div', {
      staticClass: "stories-column",
      domProps: {
        "innerHTML": _vm._s(_vm.getMissionDoc(mission, 'Lettre de mission'))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "stories-column",
      domProps: {
        "innerHTML": _vm._s(_vm.getMissionDoc(mission, 'Rapport de mission'))
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "stories-column",
      attrs: {
        "to": {
          name: 'MyTransactionsEdit',
          params: {
            id: mission.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "icon-eye"
    })])], 1)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "half docs column"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'Documents'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tVoir tous les documents\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [(_vm.lastDocuments.length === 0) ? _c('div', {
    staticClass: "no-docs empty"
  }, [_c('br'), _vm._v("Aucun documents disponibles"), _c('br'), _c('br')]) : _c('div', {
    staticClass: "docs row"
  }, _vm._l((_vm.lastDocuments), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "inner-row row"
  }, [_c('div', {
    staticClass: "half infos"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": function($event) {
        _vm.modals.editClient = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [_c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" ID client ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" #" + _vm._s(_vm.client.id))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" Nom complet ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Date de naissance")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.client.birthdate, 'DD MMMM YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Téléphone")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.phone || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Adresse mail")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.email || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Adresse postal")]), _vm._v(" "), (_vm.client.address) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.address.line || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Ville")]), _vm._v(" "), (_vm.client.address) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.address.city || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Code postal")]), _vm._v(" "), (_vm.client.address) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.client.address.zip || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column info tags"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Centres d'intérêts")]), _vm._v(" "), _c('div', {
    staticClass: "value row ctn-tags"
  }, _vm._l((_vm.client.center_of_interest), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag"
    }, [_vm._v("\n                  " + _vm._s(tag.wordpress_tag_name) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "half infos patrimoine column"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "add row"
  }, [_c('router-link', {
    staticClass: "btn btn-gold",
    attrs: {
      "to": {
        name: 'PatrimonialLandscape',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tVoir\n\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [(!_vm.estate.birthdate) ? _c('div', {
    staticClass: "no-patrimoine empty column"
  }, [_vm._v("\n\t\t\t\t\t\t\tVotre client doit remplir "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tson Paysage Patrimonial pour "), _c('br'), _vm._v("\n\t\t\t\t\t\t \tpouvoir commencer à investir.\n\t\t\t\t\t\t\t"), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.sendRelance
    }
  }, [_c('span', {
    staticClass: "icon-button-relance"
  }), _vm._v("\n\t\t\t\t\t\t\t\tEnvoyer une relance\n\t\t\t\t\t\t\t")])]) : _c('div', {
    staticClass: "patrimoines take-place"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.patrimonialConsistency = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-warning"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\tVérification de la complétude et de la cohérence des informations fournies par le client\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.computedAge(_vm.estate.birthdate) + ' ans' || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Métier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.job || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("CSP")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.csp || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Enfants")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.childs.length) + " à charge")])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Revenu annuel")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.incomes || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Immobilier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.immobilier || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Epargne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.savings || '-'))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "inner-row row"
  }, [_c('div', {
    staticClass: "half column appointment"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(8), _vm._v(" "), (_vm.client.rdvs.length > 0) ? _c('div', {
    staticClass: "add"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "boding column row"
  }, [_vm._m(9), _vm._v(" "), (_vm.client.rdvs.length === 0) ? _c('div', {
    staticClass: "no-appointment empty row"
  }, [_vm._v("\n\t\t\t\t\t\t\tPlanifiez votre première rencontre en cliquant sur \"Planifier un RDV\"\n\t\t\t\t\t\t")]) : _c('div', {
    staticClass: "appointments column"
  }, _vm._l((_vm.client.rdvs), function(rdv) {
    return _c('div', {
      staticClass: "ctn-appointment"
    }, [_c('div', {
      staticClass: "appointment-head row"
    }, [_c('div', {
      staticClass: "pastille",
      class: _vm.classResolver(rdv.type)
    }), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v(_vm._s(rdv.type))])]), _vm._v(" "), _c('div', {
      staticClass: "appointment-body row"
    }, [_c('div', {
      staticClass: "date",
      domProps: {
        "innerHTML": _vm._s(_vm.dateResolver(rdv))
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "half column flex-start"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.saveSelectedCountries
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEnregistrer\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "boding column row countries-form"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countrySearch),
      expression: "countrySearch"
    }],
    staticClass: "country-search-input",
    attrs: {
      "type": "text",
      "placeholder": "Rechercher un pays..."
    },
    domProps: {
      "value": (_vm.countrySearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.countrySearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "countries-list"
  }, _vm._l((_vm.filteredCountries), function(country) {
    return _c('div', {
      key: country.ISO2,
      staticClass: "country-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCountries),
        expression: "selectedCountries"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'country-' + country.ISO2
      },
      domProps: {
        "value": country.ISO2,
        "checked": Array.isArray(_vm.selectedCountries) ? _vm._i(_vm.selectedCountries, country.ISO2) > -1 : (_vm.selectedCountries)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCountries,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = country.ISO2,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCountries = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCountries = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCountries = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'country-' + country.fr
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(country.fr) + "\n\t\t\t\t\t\t\t\t")])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "half infos company-info-section"
  }, [_c('div', {
    staticClass: "heading row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": function($event) {
        _vm.modals.companyInfo = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tVoir / Éditer\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [(!_vm.companyInfo || !_vm.companyInfo.company_name) ? _c('div', {
    staticClass: "no-company-info empty column"
  }, [_vm._v("\n\t\t\t\t\t\tLes informations de la société"), _c('br'), _vm._v("\n\t\t\t\t\t\tdoivent être complétées pour"), _c('br'), _vm._v("\n\t\t\t\t\t\tles clients personnes morales.\n\t\t\t\t\t\t"), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.modals.companyInfo = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-warning"
  }), _vm._v("\n\t\t\t\t\t\t\tCompléter les informations\n\t\t\t\t\t\t")])]) : _c('div', {
    staticClass: "company-infos take-place"
  }, [_c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Société")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.companyInfo.company_name || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("N° immatriculation")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.companyInfo.registration_number || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Régime fiscal")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.companyInfo.tax_regime || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Activité(s)")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.companyInfo.activities || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Dirigeant(s)")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatManagers(_vm.companyInfo.managers) || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Bénéficiaire(s) effectif(s)")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatManagers(_vm.companyInfo.beneficiaries) || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" Documents transmis")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatDocument(_vm.companyInfo.documents_confirmed) || '-'))])])])])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.newNote,
      "data": _vm.modals.dataNote,
      "content": _vm.modalNewNote
    },
    on: {
      "close": function($event) {
        _vm.modals.newNote = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.editClient,
      "data": _vm.client,
      "content": _vm.modalEditClient
    },
    on: {
      "close": function($event) {
        _vm.modals.editClient = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.lcbcft,
      "content": _vm.modalLCBCFT
    },
    on: {
      "close": function($event) {
        _vm.modals.lcbcft = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.patrimonialConsistency,
      "content": _vm.modalPatrimonialConsistency
    },
    on: {
      "close": function($event) {
        _vm.modals.patrimonialConsistency = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.takeAppointment,
      "data": _vm.client,
      "content": _vm.modalTakeAppointment
    },
    on: {
      "close": function($event) {
        _vm.modals.takeAppointment = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.certified,
      "data": _vm.client,
      "content": _vm.modalCertified
    },
    on: {
      "close": _vm.handleCloseCertified
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.modals.companyInfo,
      "data": _vm.client,
      "content": _vm.modalCompanyInformation
    },
    on: {
      "close": _vm.handleCloseCompanyInfo
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content row"
  }, [_c('span', {
    staticClass: "icon-alert"
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tIdentité non vérifiée\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t\tLa vérification d'identité est impérative pour la signature des documents de mission\n\t\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content row"
  }, [_c('span', {
    staticClass: "icon-alert orange"
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tVérification d'identité en cours\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t\t\tLa vérification d'identité est impérative pour la signature des documents de mission\n\t\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-note"
  }), _vm._v("\n\t\t\t\t\t\tAjout de notes\n\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-history"
  }), _vm._v("\n\t\t\t\t\t\tHistorique\n\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stories-header row"
  }, [_c('div', {
    staticClass: "stories-column"
  }, [_vm._v("Nom")]), _vm._v(" "), _c('div', {
    staticClass: "stories-column"
  }, [_vm._v("Lettre de mission")]), _vm._v(" "), _c('div', {
    staticClass: "stories-column"
  }, [_vm._v("Compte rendu de mission")]), _vm._v(" "), _c('div', {
    staticClass: "stories-column"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-docs"
  }), _vm._v("\n\t\t\t\t\t\tDocuments récents\n\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-info"
  }), _vm._v("\n\t\t\t\t\t\t\tInformations\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-paysage"
  }), _vm._v("\n\t\t\t\t\t\t\tPaysage Patrimonial\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-calandar"
  }), _vm._v("\n\t\t\t\t\t\t\tRendez-vous\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next row"
  }, [_vm._v("\n\t\t\t\t\t\t\tProchain rendez-vous\n\t\t\t\t\t\t\t"), _c('div', {
    staticClass: "bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-calandar"
  }), _vm._v("\n\t\t\t\t\t\t\tOù sont ses placements ?\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-info"
  }), _vm._v("\n\t\t\t\t\t\tInformations Société\n\t\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49b35f16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Contacts/Client.vue
// module id = 1120
// module chunks = 0